import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ConfigStepVm } from '../tableau-de-bord.types';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-dashboard-steps',
  standalone: true,
  imports: [RouterLink],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="listep">
      <span class="stepT" [class.stepon]="steps[0]?.done" [class.stepoff]="!steps[0]?.done"
            routerLink="/configurer-general">
        <i [class]="steps[0]?.done ? 'far fa-check-circle' : 'far fa-circle'"></i>
        &nbsp;Créer sa liste de contrôle
      </span>
      <br>
      <a href="https://bo.wilout.com/fr_Fr/#/login" target="blank" style="text-decoration:none;transition-duration:0.0s;">
        <span class="stepT" [class.stepon]="steps[1]?.done" [class.stepoff]="!steps[1]?.done">
          <i [class]="steps[1]?.done ? 'far fa-check-circle' : 'far fa-circle'"></i>
          &nbsp;Configurer des billets sur Wilout Online
        </span>
      </a>
      <br>
      <span class="stepT" [class.stepon]="steps[2]?.done" [class.stepoff]="!steps[2]?.done"
            routerLink="/configurer-ma-liste">
        <i [class]="steps[2]?.done ? 'far fa-check-circle' : 'far fa-circle'"></i>
        &nbsp;Sélectionner les types de billets à contrôler
      </span>
      <br>
      <span class="stepT" [class.stepon]="steps[3]?.done" [class.stepoff]="!steps[3]?.done"
            routerLink="/gerer-les-acces">
        <i [class]="steps[3]?.done ? 'far fa-check-circle' : 'far fa-circle'"></i>
        &nbsp;Paramétrer un ou plusieurs accès
      </span>
      <br>
      <span class="stepT" [class.stepon]="steps[4]?.done" [class.stepoff]="!steps[4]?.done"
            routerLink="/gerer-les-acces">
        <i [class]="steps[4]?.done ? 'far fa-check-circle' : 'far fa-circle'"></i>
        &nbsp;Associer un accès à cette liste de contrôle
      </span>
    </div>
  `,
})
export class DashboardStepsComponent {
  @Input() steps: ConfigStepVm[] = [];
}
